import ApplicationAdapter from 'eflex/adapters/application';

export default class WebCamAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
